import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22.993 2.883A1 1 0 0 0 21 3v1H11V3l-.007-.117A1 1 0 0 0 9 3v1H6l-.15.005A2 2 0 0 0 4 6v20l.005.15A2 2 0 0 0 6 28h20l.15-.006A2 2 0 0 0 28 26V6l-.006-.15A2 2 0 0 0 26 4h-3V3zM6 12h20v14H6zm15.227 3.313a1 1 0 0 1 .044 1.322l-.086.092-5.833 5.5a1 1 0 0 1-1.273.082l-.1-.084-3.167-3a1 1 0 0 1 1.279-1.532l.096.08 2.48 2.35 5.146-4.851a1 1 0 0 1 1.414.041M23 6h3v4H6V6h3v1l.007.117A1 1 0 0 0 11 7V6h10v1l.007.117A1 1 0 0 0 23 7z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconCalendarCheck = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconCalendarCheck);
export default Memo;
